<div class="password-reset-page">
  <form class="password-reset-form" (ngSubmit)="onSubmit()">
    <!-- Logo Section -->
    <div class="password-reset-form__logo">
      <img class="password-reset-form__logo-image" src="assets/images/frankly.png" alt="CatchHub" />
    </div>

    <!-- Instructions -->
    <div class="password-reset-form__instructions">
      <p>If you can't remember your password, please enter your email address below and a reset password link will be sent to you.</p>
    </div>

    <!-- Email Field -->
    <div class="password-reset-form__content" style="margin-top: 20px">
      <mat-form-field class="password-reset-form__field">
        <mat-label>Email Address</mat-label>
        <input style="margin-top: 20px" matInput type="email" [formControl]="emailFormControl" [errorStateMatcher]="matcher" (focus)="enableSend()" />
        @if (emailFormControl.hasError('email') && !emailFormControl.hasError('required')) {
        <mat-error>Please enter a valid email address</mat-error>
        } @if (emailFormControl.hasError('required')) {
        <mat-error>Email is required</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Submit Button -->
    <div class="password-reset-form__submit">
      <button class="password-reset-form__button" mat-button color="primary" [disabled]="!sendButtonEnabled" type="submit" id="btnSend">Send</button>
    </div>

    <!-- Cancel Link -->
    <div class="password-reset-form__cancel">
      <a class="password-reset-form__link" (click)="backToLoginPage()">Cancel</a>
    </div>

    <!-- Success Message -->
    @if (passwordSent) {
    <div class="password-reset-form__success">A reset password email will be sent to {{ emailFormControl.value }} if it's a valid account.</div>
    }
  </form>
</div>
